import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrFactSheetHeaderComponent } from './kn-br-fact-sheet-header.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { PageSlotModule, SpinnerModule } from '@spartacus/storefront';
import { FormsModule } from '@angular/forms';
import { KnBrCommonAddressModule } from '../../kn-br-common-address/kn-br-common-address.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        NgbModule,
        PageSlotModule,
        FormsModule,
        SpinnerModule,
        KnBrCommonAddressModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrFactSheetHeaderComponent: {
                    component: KnBrFactSheetHeaderComponent,
                },
            },
        } as CmsConfig),
        KnBrFactSheetHeaderComponent,
    ],
})
export class KnBrFactSheetHeaderModule {}
